/** Scroll so a section sits below the fixed navbar. */
export function scrollNavTarget(el, behavior = 'smooth') {
  if (!el) return;
  const nav = document.getElementById('nav');
  const offset = (nav?.getBoundingClientRect().height ?? 82) + 16;
  const top = el.getBoundingClientRect().top + window.scrollY - offset;

  if (behavior === 'auto') {
    const root = document.documentElement;
    const previousBehavior = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollTo({ top: Math.max(0, top), left: 0, behavior: 'auto' });
    root.style.scrollBehavior = previousBehavior;
    return;
  }

  window.scrollTo({ top: Math.max(0, top), left: 0, behavior });
}
